
import React from 'react';
import { InfoSection } from '../../components';
import { homeObjOne } from './Data';

const About = () => {
  return (
    <>
      <InfoSection {...homeObjOne} />

    </>
  );
}

export default About;
